import { t } from '../../i18n/es';
import { formatNumber } from '../format';
import type { GameOverModel } from './game-over-model';

/**
 * OPERACIÓN FALLIDA (GDD §13.2, issue #61): a modal dialog over the stopped flight with the operation, the
 * points and lives already restored by the core and "Reintentar", which has the focus and goes to the
 * BRIEFING of the same level. Escape does not close it and no red is used: a game over is neither an alert
 * nor a destructive action. Native <dialog> until the design system lands (#15).
 */
export function operacionFallidaScreen(model: GameOverModel, onRetry: () => void): HTMLDialogElement {
  const dialog = document.createElement('dialog');
  dialog.className = 'dialog game-over';
  dialog.setAttribute('aria-labelledby', 'game-over-title');
  dialog.innerHTML = `
    <p class="tactical" data-field="op">${model.op} · ${t(`mission.${model.levelId}.name`).toUpperCase()}</p>
    <h1 id="game-over-title" class="display-mono">${t('ui.fallida.title')}</h1>
    <p class="body">${t('ui.fallida.body')}</p>
    <p class="readout" data-field="score">${t('ui.fallida.score', { score: formatNumber(model.score) })}</p>
    <p class="readout" data-field="lives">${t('ui.fallida.lives', { lives: model.lives })}</p>
    <div class="slot-actions">
      <button type="button" class="button" data-action="retry">${t('ui.fallida.retry')}</button>
    </div>`;
  dialog.addEventListener('cancel', (event) => event.preventDefault());
  const retry = dialog.querySelector<HTMLButtonElement>('[data-action="retry"]')!;
  retry.addEventListener('click', onRetry);
  queueMicrotask(() => {
    if (!dialog.isConnected) return;
    dialog.showModal();
    retry.focus();
  });
  return dialog;
}
